import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { createCategory } from "../../api/apiCategories";
import parseError from "../../utils/parseError";
import { useNavigate } from "react-router-dom";

/**
 * Hook لإنشاء فئة جديدة
 */
export function useCreateCategory() {
    const queryClient = useQueryClient();
    const navigate = useNavigate();

    const {
        mutate: createCategoryMutate,
        isPending,
    } = useMutation({
        mutationFn: createCategory,
        onSuccess: (response) => {
            toast.success(response.message || "Created successfully");
            queryClient.invalidateQueries({ queryKey: ["categories"] });
            navigate('/categories');
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to create category");
        },
    });

    return {
        createCategoryMutate,
        isPending,
    };
}
